export default __webpack_public_path__ + "static/media/AstronomyVenus_10.a85f3c24.png";